import { Validators } from '@angular/forms';

export class LoanTermsModel {
    repaymentFrequency = {
        value: null,
        validation: Validators.compose([
            Validators.required
        ])
    };
    loanTermId = {
        value: null,
        validation: Validators.compose([
            Validators.required
        ])
    };
    loanTerm = {
      value: null,
      validation: Validators.compose([])
    };
}
